export default __webpack_public_path__ + "static/media/informationImage4.e85bb414.svg";